

import {Component, Vue, Watch} from "vue-property-decorator";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import TopluHacizHazirlaFormWizard from "@/components/forms/form-wizard/eicrapro/TopluHacizHazirlaFormWizard.vue";
import {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import sorguOneriService, {SorguOneriRow} from "@/services/sorguOneriService";
import {
  borcluKisiKurumId,
  borcluSecimiDaralt,
  hedefVarlikSecimiDaralt,
  KopruGirdisi,
  kopruGirdisiUret,
  kopruHalaGecerliMi,
  sihirbazaUygula,
  VarlikDaraltmaSonucu
} from "@/services/sorguOneriKopru";
import {denemeSonrasiEylem, kopruOtomatikGonderimKarari} from "@/views/eicrapro/topluHacizKopruDeneme";

/** Sihirbaz ağacının kurulmasını beklerken yapılacak azami deneme sayısı. */
const AZAMI_UYGULAMA_DENEMESI = 30;

/**
 * Toplu Haciz Hazırla sayfası + haciz önerisi köprüsü (F2-İP6, DEV-2953).
 *
 * Sihirbazın KENDİSİ değiştirilmez. Köprü yalnız bu görünümden, sihirbazın zaten
 * dışa açık olan alanlarına yazarak kurulur (bkz. `sorguOneriKopru.sihirbazaUygula`).
 *
 * icrapro takip eşleşmesi GEREKMEZ: sihirbaz `takip_id` kullanmaz, dosya
 * eşleştirmesi `birimId + dosyaNo` ikilisiyle yapılır.
 */
@Component({
  components: {UyapBagliDegilView, TopluHacizHazirlaFormWizard}
})
export default class TopluHacizHazirlaView extends Vue {
  taskTuru = TaskTuru;

  /** Köprü çözümlemesi bitti mi — sihirbaz ancak bundan sonra kurulmalı. */
  hazir = false;
  /** Sihirbaza `value` olarak verilecek ön dolu form durumu. */
  onDoldurulmus: GenelIslemEntity | undefined = undefined;
  kopruGirdisi: KopruGirdisi | null = null;
  kopruBaslik = "";
  /** Köprü kurulmuşken kullanıcı listelemeyi yenilediği için ön seçim düştü mü. */
  kopruDustu = false;
  /**
   * Deneme UYAP bağlı DEĞİLKEN tükendi — bu bir düşme değil, bekleme (B09,
   * DEV-2603): `kopruGirdisi` korunur, `onUyapBaglantisiDegisti` UYAP
   * bağlanınca yeniden dener. Yalnız şeridin metnini değiştirir.
   */
  kopruUyapBekliyor = false;
  /** Öneriye konu borçlunun UYAP kişi/kurum kimliği (F2-K7 daraltması). */
  hedefKisiKurumId: number | null = null;
  borcluDaraltildi = false;
  /** "Talepleri Hazırla" sonrası varlık daraltmasının son sonucu. */
  varlikSonucu: VarlikDaraltmaSonucu = {tur: null, durum: "desteklenmiyor", kaldirilan: 0};
  /**
   * Sihirbazda "otomatik gönder" seçeneği açık mı — açıksa daraltma yetişemez
   * (bkz. docs/sorgu-snapshot-gecmis.md, 10 Eylül DEV-3345/B11). `$refs` reaktif olmadığı için getter yerine, sihirbaz
   * referansı elimizdeyken kurulan bir izleyiciyle taşınır.
   *
   * B11 (DEV-3345): köprüden gelindiğinde bu anahtar artık sayfa örneği için
   * zorla kapatılıyor (bkz. `kopruOtomatikGonderimKarari`); bu bayrak yalnız
   * kullanıcı anahtarı ELLE yeniden açtığında true olur — o yol korunur.
   */
  otomatikGonderimAcik = false;
  /** B11 (DEV-3345): "öneriden gelindiği için kapatıldı" bilgisi gösterilsin mi. */
  otomatikGonderimKapatildiBilgisi = false;
  /**
   * Anahtar bu sayfa örneğinde daha önce zorla kapatıldı mı — `kopruOtomatikGonderimKarari`
   * bunu yalnız İLK kez kapatmak için kullanır; kalıcı bir tercihe YAZILMAZ,
   * yalnız bellekte bu örnek için tutulur (B11, DEV-3345).
   */
  otomatikGonderimZorlaKapatildi = false;
  /** Görevler kuyruğa alındığında `gorev_olusturuldu` yapılacak öneri. */
  bekleyenOneriId: number | null = null;

  aksiyonAboneligi: (() => void) | null = null;
  gecerlilikIzleyicisi: (() => void) | null = null;
  borcluIzleyicisi: (() => void) | null = null;
  uygulamaDenemesi = 0;

  get varlikAdi(): string {
    return this.varlikSonucu.tur === "tasinmaz" ? "taşınmaz" : "araç";
  }

  get varlikBelirsiz(): boolean {
    return this.varlikSonucu.durum === "belirsiz";
  }

  /**
   * Bilgi şeridinin varlık cümlesi. Üç durum ayrı ayrı söylenir; hepsini tek
   * "sonra yapılacak" cümlesiyle geçmek, zaten doğru seçilmiş tek varlıklı
   * dosyada köprünün çalışmadığı izlenimi veriyordu.
   */
  get varlikDurumMetni(): string {
    if (this.varlikSonucu.tur === null) {
      // Banka/maaş: gönderim seçimi ayrı bir veri yolundan besleniyor, daraltılamaz.
      return "";
    }
    if (this.varlikSonucu.durum === "eslesti") {
      const ad = this.varlikAdi.charAt(0).toLocaleUpperCase("tr") + this.varlikAdi.slice(1);
      return this.varlikSonucu.kaldirilan > 0
          ? ad + " seçimi öneriye konu kayda daraltıldı."
          : ad + " seçimi öneriyle uyumlu.";
    }
    if (this.varlikSonucu.durum === "belirsiz") {
      return "";
    }
    return "Varlık seçimi \"Talepleri Hazırla\" adımı bittikten sonra bu ekranda yapılır.";
  }

  get kopruIstendiMi(): boolean {
    return typeof this.$route.query.oneri === "string" && this.$route.query.oneri !== "";
  }

  async created() {
    if (!this.kopruIstendiMi) {
      this.hazir = true;
      return;
    }
    try {
      await this.kopruyuKur();
    } catch (e) {
      // Köprü kurulamazsa sihirbaz normal (boş) haliyle açılır — özellik kaybı
      // olur ama sayfa çalışmaya devam eder.
      this.kopruGirdisi = null;
      this.onDoldurulmus = undefined;
    } finally {
      this.hazir = true;
      this.sihirbazaYazmayiDene();
    }
  }

  mounted() {
    // Sihirbaz görevleri `postTasks` ile kuyruğa alıp sayfadan ayrılıyor. Öneriyi
    // ancak o an "görev oluşturuldu" saymak doğru: kullanıcı sihirbazı yarıda
    // bırakırsa öneri açık kalmalı (yanlış yere kalıcı olarak susturulmamalı).
    this.aksiyonAboneligi = this.$store.subscribeAction({
      after: (action: any) => {
        if (action.type !== "postTasks" || this.bekleyenOneriId === null) return;
        const id = this.bekleyenOneriId;
        this.bekleyenOneriId = null;
        this.$store.dispatch("sorguOneri/gorevOlusturulduIsaretle", id).catch(() => {
          // Durum yazılamazsa öneri açık kalır; bir sonraki listede yine görünür.
        });
      }
    });
  }

  beforeDestroy() {
    this.izleyicileriBirak();
    if (this.aksiyonAboneligi) {
      this.aksiyonAboneligi();
      this.aksiyonAboneligi = null;
    }
    this.$store.dispatch("sorguOneri/koprulenenTemizle");
  }

  /**
   * UYAP bağlantısı sayfa açıldıktan SONRA kurulursa sihirbaz o an mount olur;
   * ön doldurma yeniden denenmelidir. Bu yol B09 (DEV-2603) düzeltmesinden
   * ÖNCE kalıcı olarak ölebiliyordu: denemeler UYAP bağlı değilken tükendiğinde
   * eski kod `kopruDustu`yu koşulsuz `true` yapıyordu, bu bayrak bir daha
   * `false` olmadığı için aşağıdaki `!this.kopruDustu` koşulu asla
   * sağlanmıyordu. Artık `denemeSonrasiEylem` UYAP bağlı değilken tükenmeyi
   * "uyap-bekle" sayıyor ve `kopruDustu`yu false bırakıyor — bu izleyici
   * normal şekilde tetiklenip yeniden dener.
   */
  @Watch("$store.getters.isUyapConnected")
  onUyapBaglantisiDegisti(bagli: boolean) {
    if (bagli && this.kopruGirdisi && !this.kopruDustu) {
      this.uygulamaDenemesi = 0;
      this.sihirbazaYazmayiDene();
    }
  }

  /** Köprüyü doğuran öneriyi bulur ve ön dolu form durumunu hazırlar. */
  async kopruyuKur() {
    const oneri = await this.oneriyiBul();
    if (!oneri) return;

    const birimAdi = await this.birimAdiCoz(oneri.dosya_ref);
    const girdi = kopruGirdisiUret(oneri, birimAdi);
    if (!girdi) return;

    const entity = new GenelIslemEntity();
    // Satır hem tabloya hem seçime konur; ikisi AYNI nesne olmalı, tablo
    // `item-key="index"` ile eşleştiriyor.
    entity.takipler = [girdi.takip];
    entity.secilen_takipler = [girdi.takip];

    this.onDoldurulmus = entity;
    this.kopruGirdisi = girdi;
    this.kopruBaslik = oneri.baslik;
    this.hedefKisiKurumId = borcluKisiKurumId(oneri);
    this.bekleyenOneriId = oneri.id;
  }

  /**
   * Öneri önce store'dan okunur (kartın bıraktığı hızlı yol); sayfa doğrudan
   * açıldıysa/yenilendiyse `dosya_ref` ile uçtan çekilir.
   */
  async oneriyiBul(): Promise<SorguOneriRow | null> {
    const id = Number(this.$route.query.oneri);
    if (!id || isNaN(id)) return null;

    const saklanan: SorguOneriRow | null = this.$store.getters["sorguOneri/koprulenenOneri"];
    if (saklanan && saklanan.id === id) return saklanan;

    const dosyaRef = typeof this.$route.query.dosya_ref === "string" ? this.$route.query.dosya_ref : "";
    if (!dosyaRef) return null;

    const oneriler = await sorguOneriService.listele({dosya_ref: dosyaRef});
    return oneriler.find((oneri) => oneri.id === id) ?? null;
  }

  /**
   * `dosya_ref` yalnız birimId taşır; birim ADI tabloda gösterilecek diye UYAP'ın
   * önbellekli birim listesinden çözülür (sihirbazın 1. adımda kullandığı aynı
   * istek, 8 saat önbellekli). Çözülemezse boş kalır — dosya eşleştirmesi zaten
   * birimId üzerinden yapılıyor, ad yalnız gösterim içindir.
   */
  async birimAdiCoz(dosyaRef: string): Promise<string> {
    const birimId = dosyaRef.split(":")[0];
    if (!birimId) return "";
    try {
      const cevap = await this.$uyap.MahkemeBirimleri().run({
        yargiTuru: 2,
        yargiBirimi: "1101",
        dosyaKapaliMi: false
      } as any);
      const birim = (cevap?.items ?? []).find((item: any) => String(item.birimId) === String(birimId));
      return birim?.birimAdi ?? "";
    } catch (e) {
      return "";
    }
  }

  /**
   * Ön doldurmayı sihirbaza yazar; sihirbaz ağacı henüz kurulmadıysa bir sonraki
   * tick'te tekrar dener. Tek `$nextTick` yeterli olmuyor: `hazir` bayrağı
   * sihirbazı yeni oluşturuyor, iç `GenelIslemFormWizard`'ın `@Ref`'i ancak o
   * ağaç mount olduktan sonra doluyor.
   */
  sihirbazaYazmayiDene() {
    if (!this.kopruGirdisi || this.kopruDustu) return;

    this.$nextTick(() => {
      const sihirbaz: any = this.$refs.wizard;
      const sonuc = sihirbazaUygula(sihirbaz, this.kopruGirdisi, this.talepKaydiBul());

      if (sonuc.tamam) {
        this.uygulamaDenemesi = 0;
        this.kopruUyapBekliyor = false;
        this.izleyicileriKur(sihirbaz);
        return;
      }

      const eylem = denemeSonrasiEylem(
          ++this.uygulamaDenemesi,
          AZAMI_UYGULAMA_DENEMESI,
          this.$store.getters.isUyapConnected
      );

      if (eylem === "tekrar-dene") {
        this.sihirbazaYazmayiDene();
        return;
      }

      if (eylem === "uyap-bekle") {
        // Denemeler UYAP BAĞLI DEĞİLKEN tükendi (bkz. şablondaki
        // `hazir && isUyapConnected` koşulu — bağlı değilken `$refs.wizard`
        // hiç var olmaz, 30 denemenin tamamı bu yüzden başarısız oldu). Bu
        // gerçek bir düşme değil: kopruGirdisi KORUNUR, kopruDustu false
        // kalır ki onUyapBaglantisiDegisti UYAP bağlanınca yeniden densin.
        this.kopruUyapBekliyor = true;
        return;
      }

      // "vazgec": UYAP bağlıyken bile denemeler tükendi, sihirbaz ağacı hiç
      // kurulamadı — bu gerçek bir düşme. Üstteki şerit "önceden seçildi"
      // demeye devam etmesin diye köprü düşürülür (bkz. kopruyuDusur,
      // gecerlilikIzleyicisi callback'i de aynısını kullanır).
      this.kopruyuDusur();
    });
  }

  /** Kuralın karşılığı talep türünü UYAP'ın statik haciz evrakı kataloğundan bulur. */
  talepKaydiBul(): any {
    if (!this.kopruGirdisi) return null;
    const kod = this.kopruGirdisi.talepKodu;
    return new MDB().hacizEvrakTipleri.find((satir: any) => satir.talepKodu === kod) ?? null;
  }

  /**
   * Üç izleyici kurar:
   *  1. Ön seçim hâlâ duruyor mu — kullanıcı 1. adıma dönüp yeniden listelerse
   *     sihirbaz `secilen_takipler`'i sıfırlıyor; o an köprü geçersizleşir.
   *  2. Otomatik gönderim anahtarı açık mı (B11/DEV-3345) — köprüyle gelindiğinde
   *     gerekiyorsa uyarı gösterilir/anahtar zorla kapatılır.
   *  3. Borçlular yüklendi mi — "Hazırla" adımı bitince sihirbaz dosyadaki TÜM
   *     borçluları işaretliyor, seçim öneriye konu borçluya daraltılır (F2-K7).
   */
  izleyicileriKur(sihirbaz: any) {
    this.izleyicileriBirak();

    this.gecerlilikIzleyicisi = this.$watch(
        () => kopruHalaGecerliMi(sihirbaz, this.kopruGirdisi),
        (gecerli: boolean) => {
          if (gecerli) return;
          // Köprü düştü (bkz. kopruyuDusur).
          this.kopruyuDusur();
        }
    );

    // Tetik, borçlu listesinin GÖRÜNMESİ değil sihirbazın `durum` alanının
    // `hazir`e geçmesidir. Neden: `task.response` atandığı an (handler'ın içinde)
    // izleyici kuyruğa giriyor ve `await handler.handle(task)`'in devamından ÖNCE
    // çalışıyor; sihirbaz ise o devamda dosyadaki TÜM borçlulara koşulsuz
    // `selected = true` yazıyor. Liste izleyicisi kullanılırsa daraltma yazılıp
    // hemen üzerine yazılıyordu. `durum = hazir` (TopluHacizHazirlaFormWizard'ın
    // hazırlama döngüsünün BİTİMİNDE) yarışı yapısal olarak ortadan kaldırır ve
    // "Talepleri Hazırla" ikinci kez çalıştırıldığında da yeniden tetiklenir
    // (`hazirlaniyor` → `hazir`).
    // B11 (DEV-3345): açıkken narrow'un yetişemediği aynı yarış — bkz.
    // `kopruOtomatikGonderimKarari` başındaki açıklama. `immediate: true`
    // sayesinde bu callback izleyici kurulur kurulmaz bir kez de kendiliğinden
    // çalışır; anahtar o an açık gelmiş olsa bile (ör. sihirbaz örneği başka
    // bir akıştan kalma reaktif durumu taşıyorsa) burada bellekte kapatılır —
    // kalıcı bir tercihe DOKUNULMAZ, yalnız bu sayfa örneğinde.
    this.otomatikGonderimIzleyicisi = this.$watch(
        () => sihirbaz?.otomatikTalepGonder === true,
        (acik: boolean) => {
          const karar = kopruOtomatikGonderimKarari(
              this.kopruGirdisi !== null,
              acik,
              this.otomatikGonderimZorlaKapatildi
          );
          this.otomatikGonderimAcik = karar.acikUyarisiGoster;
          this.otomatikGonderimKapatildiBilgisi = karar.kapatildiBilgisiGoster;
          if (karar.zorlaKapat && sihirbaz) {
            this.otomatikGonderimZorlaKapatildi = true;
            sihirbaz.otomatikTalepGonder = false;
          }
        },
        {immediate: true}
    );

    this.borcluIzleyicisi = this.$watch(
        () => sihirbaz?.durum,
        (yeniDurum: any) => {
          if (yeniDurum === sihirbaz?.topluHacizDurum?.hazir) {
            this.borcluSecimiDaralt(sihirbaz);
          }
        }
    );
  }

  otomatikGonderimIzleyicisi: (() => void) | null = null;

  izleyicileriBirak() {
    if (this.gecerlilikIzleyicisi) {
      this.gecerlilikIzleyicisi();
      this.gecerlilikIzleyicisi = null;
    }
    if (this.borcluIzleyicisi) {
      this.borcluIzleyicisi();
      this.borcluIzleyicisi = null;
    }
    if (this.otomatikGonderimIzleyicisi) {
      this.otomatikGonderimIzleyicisi();
      this.otomatikGonderimIzleyicisi = null;
    }
  }

  /**
   * Köprüyü düşürür: bilgi şeridi yalan söylememeli, öneri de kuyruğa alınan
   * ALAKASIZ görevler yüzünden "görev oluşturuldu" işaretlenmemeli.
   *
   * kod inceleme: "vazgeç" dalı ile gecerlilikIzleyicisi callback'inde birebir
   * tekrar eden dört atama tek yerde toplandı.
   */
  private kopruyuDusur() {
    this.kopruGirdisi = null;
    this.bekleyenOneriId = null;
    this.kopruDustu = true;
    this.izleyicileriBirak();
  }

  /**
   * kod inceleme: `hedefBorcluDizisi()` ayrı bir katman olarak vardı ("İzleyici
   * KİMLİK bazlı izliyor" gerekçesiyle) ama tek çağrı yeri (`borcluSecimiDaralt`)
   * bir $watch getter'ı içinde değil, callback'te imperatif çağrılıyor — dönüş
   * değerinin kimliğini izleyen bir reaktif bağımlılık yok. Gerekçe geçersizdi,
   * katman kaldırıldı.
   */
  hedefTakipBorclulari(): any[] {
    const takip: any = this.kopruGirdisi?.takip;
    const borclular = takip?.task?.response?.borclular;
    return Array.isArray(borclular) ? borclular : [];
  }

  /**
   * "Talepleri Hazırla" bittikten sonra seçimleri öneriye daraltır: önce borçlu,
   * sonra o borçlunun varlık listesi (araç/taşınmaz).
   *
   * Zamanlama: `TopluHacizHazirlaTaskHandler` EGM/TAKBİS sorgularını
   * `response.borclular` dışa açılmadan ÖNCE bitiriyor, dolayısıyla borçlu sayısı
   * değiştiğinde varlık listeleri (ve parser'ın koşulsuz yazdığı `selected = true`
   * bayrakları) çoktan hazır. Ayrı bir izleyiciye gerek yok.
   */
  borcluSecimiDaralt(sihirbaz: any) {
    if (this.hedefKisiKurumId === null) return;

    // Her tur bastan hesaplanir: bir onceki kosumda daraltilmis olmak, bu kosumda
    // (or. belirsizlesen bir varlik listesiyle) daraltildigi anlamina gelmez.
    this.borcluDaraltildi = false;

    const yaz = (hedef: any, alan: string, deger: any) => this.$set(hedef, alan, deger);
    const borclular = this.hedefTakipBorclulari();

    const kaldirilan = borcluSecimiDaralt(borclular, this.hedefKisiKurumId, yaz);
    this.varlikSonucu = hedefVarlikSecimiDaralt(
        borclular.find((borclu: any) => Number(borclu?.kisiKurumId) === this.hedefKisiKurumId),
        this.kopruGirdisi,
        yaz
    );

    if (kaldirilan === 0 && this.varlikSonucu.kaldirilan === 0) return;

    if (kaldirilan > 0) {
      this.borcluDaraltildi = true;
    }
    // `selected`, DosyaBorclu'da tanımlı bir alan DEĞİL; borçlular gözlemlendikten
    // sonra eklendiği için Vue onu izlemiyor ve onay kutusu kendiliğinden
    // güncellenmiyor. Sihirbazın kendi `input()`'u da bu yüzden `$forceUpdate`
    // çağırıyor — aynı yol kullanılır, yoksa kullanıcı seçili görünen ama
    // gönderilmeyecek borçlu görürdü.
    if (typeof sihirbaz?.input === "function") {
      sihirbaz.input();
    }
  }
}
